import { supabase } from '../lib/supabase';

// Helper: Convert snake_case to camelCase
const toCamelCase = (obj) => {
  if (!obj || typeof obj !== 'object') return obj;
  if (Array.isArray(obj)) return obj?.map(toCamelCase);

  return Object.keys(obj)?.reduce((acc, key) => {
    const camelKey = key?.replace(/_([a-z])/g, (_, letter) => letter?.toUpperCase());
    acc[camelKey] = typeof obj?.[key] === 'object' ? toCamelCase(obj?.[key]) : obj?.[key];
    return acc;
  }, {});
};

// Get or create session ID
const getSessionId = () => {
  let sessionId = sessionStorage.getItem('sessionId');
  if (!sessionId) {
    sessionId = `session_${Date.now()}_${Math.random()?.toString(36)?.substr(2, 9)}`;
    sessionStorage.setItem('sessionId', sessionId);
  }
  return sessionId;
};

// Check if revealed today
export const hasRevealedToday = async () => {
  try {
    let sessionId = getSessionId();
    const today = new Date()?.toISOString()?.split('T')?.[0];
    
    const { data, error } = await supabase?.from('reveal_tracking')?.select('*')?.eq('session_id', sessionId)?.eq('reveal_date', today)?.maybeSingle();

    if (error) throw error;
    return { data: data ? toCamelCase(data) : null, error: null };
  } catch (error) {
    console.error('Error checking reveal status:', error);
    return { data: null, error };
  }
};

// Track reveal
export const trackReveal = async (contentType) => {
  try {
    let sessionId = getSessionId();
    const today = new Date()?.toISOString()?.split('T')?.[0];
    
    const { data, error } = await supabase?.from('reveal_tracking')?.insert({
        session_id: sessionId,
        reveal_date: today,
        content_type: contentType
      })?.select()?.single();

    if (error) {
      // Already revealed today
      if (error?.code === '23505') {
        return { data: null, error: { message: 'Already revealed today' } };
      }
      throw error;
    }
    
    return { data: toCamelCase(data), error: null };
  } catch (error) {
    console.error('Error tracking reveal:', error);
    return { data: null, error };
  }
};